export const DOCUMENT_TYPE_INSURANCE_GUIDEBOOK = 'insurance-guidebook';
